// extracted by mini-css-extract-plugin
export var blue = "#0eb3f2";
export var date = "MatchPage-module--date--cf09a";
export var emphasis = "MatchPage-module--emphasis--2dc93";
export var filter = "MatchPage-module--filter--124d1";
export var green = "#57d33b";
export var greenLink = "MatchPage-module--green-link--cde8b";
export var grey = "var(--tone-mid)";
export var marketName = "MatchPage-module--marketName--b17b2";
export var match = "MatchPage-module--match--66e42";
export var myBets = "MatchPage-module--myBets--91f02";
export var notchGap = "32px";
export var orange = "#f8662b";
export var outright = "MatchPage-module--outright--718b3";
export var outrightHeader = "MatchPage-module--outrightHeader--5eb84";
export var outrightTitleIcon = "MatchPage-module--outrightTitleIcon--ae10a";
export var red = "#ff2741";
export var selectionIcon = "MatchPage-module--selectionIcon--ba661";
export var selectionName = "MatchPage-module--selectionName--c87e9";
export var sgmCompetitor = "MatchPage-module--sgmCompetitor--332af";
export var statusAndStream = "MatchPage-module--statusAndStream--54939";
export var tabGutter = "MatchPage-module--tabGutter--80c48";
export var timer = "MatchPage-module--timer--c5361";
export var title = "MatchPage-module--title--c0bcd";
export var titleIcon = "MatchPage-module--titleIcon--02782";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var yellow = "#ffb100";